export const Channels = {
  WHOLESALER: 'PR',
  RETAIL: 'DT',
  EXPORT: 'EX',
  INDUSTRIAL: 'IN',
  MODERN: 'MD',
  PROJECT: 'PG',
  ECOMMERCE: 'GR',
};
